<template>
  <div class="minewrapper">
    <template v-for="(item, index) in mineItemList" :key="index">
      <van-cell
        class="mine__cell"
        :title="item.title"
        is-link
        :icon="item.icon"
        @click="onCellClick(item.to)"
      />
    </template>
  </div>
</template>

<script>
import { ref, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { showConfirmDialog } from "vant";
import { useI18n } from "vue-i18n";
import {
  saveLoginAccessToken,
  saveLoginRefreshToken,
  getLoginAccessToken,
  getLoginRefreshToken,
  saveUserInfo,
  getUserInfo,
  isInChinaCountry,
  isLogin,
  logout,
  isFirstLevelDistributor,
} from "@/utils/localStorageUtils";

const useChangeItemLanguageEffect = (t) => {
  // 根据当前的用户 来返回具体的ITEM
  const userInfo = getUserInfo();
  const userType = userInfo ? userInfo.userType : "";
  const tempType = userInfo ? userInfo.tempflag : "";

  let itemList = [];
  if (userType == "SYSTEM_USER") {
    // 系统用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      // 质保相关
      [
        // 质保创建
        // {
        //   title: t("app.mineitem.mycreateqaitem"),
        //   icon: "add-o",
        //   to: "QaFormStepOne",
        // },
        // 质保查询
        {
          title: t("app.mineitem.myqueryqaitem"),
          icon: "search",
          to: "QaList",
        },
        // 质保管理
        // {
        //   title: t("app.mineitem.myqareviewitem"),
        //   icon: "label-o",
        //   to: "QaReview",
        // },
      ],

      // 采购下单、订单管理
      // [
      //   {
      //     title: t("app.mineitem.myshopitem"),
      //     icon: "bag-o",
      //     to: "ShopList",
      //   },
      //   {
      //     title: t("app.mineitem.myorderitem"),
      //     icon: "goods-collect-o",
      //     to: "PurchaseOrder",
      //   },
      // ],

      // 库存相关
      // [
      //   {
      //     title: t("app.mineitem.mystockinitem"),
      //     icon: "plus",
      //     to: "StockIn",
      //   },
      //   {
      //     title: t("app.mineitem.mystockoutitem"),
      //     icon: "minus",
      //     to: "StockOut",
      //   },
      // ],

      // 经销商门店/零售商   人员管理
      // [
      //   {
      //     title: t("app.mineitem.mydealermanageritem"),
      //     icon: "apps-o",
      //     to: "DealerShopManager",
      //   },
      //   {
      //     title: t("app.mineitem.workerlist"),
      //     icon: "bars",
      //     to: "WorkerList",
      //   },
      // ],

      // 券码管理/核销
      // [
      //   // {
      //   //   title: t("app.mineitem.mycouponitem"),
      //   //   icon: "coupon-o",
      //   //   to: "Coupon",
      //   // },
      //   {
      //     title: t("app.mineitem.couponmanageitem"),
      //     icon: "cluster-o",
      //     to: "DealerCoupon",
      //   },
      //   {
      //     title: t("app.mineitem.mycouponcheckitem"),
      //     icon: "scan",
      //     to: "CouponScan",
      //   },
      // ],
      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "INDIVIDUAL_USER") {
    // 个人消费者
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      // 质保相关
      [
        // 质保创建
        {
          title: t("app.mineitem.mycreateqaitem"),
          icon: "add-o",
          to: "QaForm",
        },
        // 质保查询
        {
          title: t("app.mineitem.myqueryqaitem"),
          icon: "search",
          to: "QaList",
        },
        // 质保管理
        // {
        //   title: t("app.mineitem.myqareviewitem"),
        //   icon: "label-o",
        //   to: "QaReview",
        // },
      ],

      // 商品购买（仅国内个人消费者可见，进入消费者选品下单流程）
      ...(isInChinaCountry()
        ? [
            [
              {
                title: t("app.mineitem.myproductpurchaseitem"),
                icon: "shopping-cart-o",
                to: "ConsumerRetailerList",
              },
            ],
          ]
        : []),

      // 订单管理
      [
        {
          title: t("app.nav.purchase_order"),
          icon: "orders-o",
          to: "ConsumerOrderList",
        },
        {
          title: t("app.mineitem.mypaymentorderbillmanageritem"),
          icon: "bill-o",
          to: "ConsumerPaymentBillList",
        },
      ],

      // 地址相关
      [
        // 地址管理
        {
          title: t("app.mineitem.addressmanager"),
          icon: "location-o",
          to: "AddressList",
        },
      ],

      // 购买订单
      // [
      //   {
      //     title: t("app.mineitem.mypaymentorderitem"),
      //     icon: "shopping-cart-o",
      //     to: "ShopOrderList",
      //   },

      //   {
      //     title: t("app.mineitem.mypaymentorderbillmanageritem"),
      //     icon: "bill-o",
      //     to: "PaymentBillManageBuyer",
      //   },
      // ],

      // 交易订单管理
      // [
      //   {
      //     title: t("app.mineitem.mypaymentorderitem"),
      //     icon: "shopping-cart-o",
      //     to: "ShopOrderList",
      //   },
      //   // {
      //   //   title: t("app.mineitem.mypaymentordermanageritem"),
      //   //   icon: "goods-collect-o",
      //   //   to: "PaymentOrder",
      //   // },
      // ],

      // 采购下单、订单管理
      // [
      //   {
      //     title: t("app.mineitem.myshopitem"),
      //     icon: "bag-o",
      //     to: "ShopList",
      //   },
      //   // {
      //   //   title: t("app.mineitem.myorderitem"),
      //   //   icon: "goods-collect-o",
      //   //   to: "PurchaseOrder",
      //   // },
      // ],

      // 库存相关
      // [
      //   {
      //     title: t("app.mineitem.mystockinitem"),
      //     icon: "plus",
      //     to: "StockIn",
      //   },
      //   {
      //     title: t("app.mineitem.mystockoutitem"),
      //     icon: "minus",
      //     to: "StockOut",
      //   },
      // ],

      // 经销商门店/零售商   人员管理
      // [
      //   {
      //     title: t("app.mineitem.mydealermanageritem"),
      //     icon: "apps-o",
      //     to: "DealerShopManager",
      //   },
      //   {
      //     title: t("app.mineitem.workerlist"),
      //     icon: "bars",
      //     to: "WorkerList",
      //   },
      // ],

      // 券码管理/核销
      // [
      //   {
      //     title: t("app.mineitem.mycouponitem"),
      //     icon: "coupon-o",
      //     to: "Coupon",
      //   },
      //   // {
      //   //   title: t("app.mineitem.couponmanageitem"),
      //   //   icon: "cluster-o",
      //   //   to: "DealerCoupon",
      //   // },
      //   // {
      //   //   title: t("app.mineitem.mycouponcheckitem"),
      //   //   icon: "scan",
      //   //   to: "CouponScan",
      //   // },
      // ],
      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "SUPPLIER_USER") {
    // 供应商用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],
      // 库存相关
      [
        // {
        //   title: t("app.mineitem.mystockinitem"),
        //   icon: "plus",
        //   to: "StockIn",
        // },
        // 创建库存
        {
          title: t("app.mineitem.mycreatestockitem"),
          icon: "plus",
          to: "StockCreate",
        },
        {
          title: t("app.mineitem.mystockoutitem"),
          icon: "minus",
          to: "StockOut",
        },
      ],

      // 创建库存
      // [
      //   {
      //     title: t("app.mineitem.mycreatestockitem"),
      //     icon: "plus",
      //     to: "StockCreate",
      //   },
      // ],

      // 经销商门店/零售商   人员管理
      [
        {
          title: t("app.mineitem.workerlist"),
          icon: "bars",
          to: "WorkerList",
        },
      ],

      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "DISTRIBUTOR_USER") {
    if (isFirstLevelDistributor()) {
      // 分销商用户
      itemList = [
        // 序列号校验
        [
          {
            title: t("app.mineitem.mysecuritycheckitem"),
            icon: "font-o",
            to: "SecurityCheck",
          },
        ],

        // 质保相关
        [
          // 质保创建
          // {
          //   title: t("app.mineitem.mycreateqaitem"),
          //   icon: "add-o",
          //   to: "QaForm",
          // },
          // 质保查询
          // {
          //   title: t("app.mineitem.myqueryqaitem"),
          //   icon: "search",
          //   to: "QaList",
          // },
          // 质保管理
          {
            title: t("app.mineitem.myqareviewitem"),
            icon: "label-o",
            to: "QaReview",
          },
        ],

        // 索赔审批
        [
          {
            title: t("app.mineitem.myclaimapprovalitem"),
            icon: "todo-list-o",
            to: "ClaimApproval",
          },
        ],

        // 交易订单管理
        [
          {
            title: t("app.mineitem.mypaymentorderitem"),
            icon: "shopping-cart-o",
            to: "ShopOrderList",
          },

          {
            title: t("app.mineitem.mypaymentorderbillmanageritem"),
            icon: "bill-o",
            to: "PaymentBillManageBuyer",
          },
          // {
          //   title: t("app.mineitem.mypaymentordermanageritem"),
          //   icon: "goods-collect-o",
          //   to: "PaymentOrder",
          // },
        ],

        // 采购下单、订单管理
        [
          // {
          //   title: t("app.mineitem.myshopitem"),
          //   icon: "bag-o",
          //   to: "ShopList",
          // },
          {
            title: t("app.mineitem.myorderitem"),
            icon: "goods-collect-o",
            to: "PurchaseOrder",
          },
        ],

        // 库存相关
        [
          {
            title: t("app.mineitem.mystockinitem"),
            icon: "plus",
            to: "StockIn",
          },
          {
            title: t("app.mineitem.mystockoutitem"),
            icon: "minus",
            to: "StockOut",
          },
        ],

        // 创建库存
        // [
        //   {
        //     title: t("app.mineitem.mystockinitem"),
        //     icon: "plus",
        //     to: "StockCreate",
        //   },
        // ],

        // 经销商门店/零售商   人员管理
        [
          {
            title: t("app.mineitem.mydealermanageritem"),
            icon: "apps-o",
            to: "DealerShopManager",
          },
          {
            title: t("app.mineitem.workerlist"),
            icon: "bars",
            to: "WorkerList",
          },
        ],

        // 券码管理/核销
        // [
        //   // {
        //   //   title: t("app.mineitem.mycouponitem"),
        //   //   icon: "coupon-o",
        //   //   to: "Coupon",
        //   // },
        //   {
        //     title: t("app.mineitem.couponmanageitem"),
        //     icon: "cluster-o",
        //     to: "DealerCoupon",
        //   },
        //   // {
        //   //   title: t("app.mineitem.mycouponcheckitem"),
        //   //   icon: "scan",
        //   //   to: "CouponScan",
        //   // },
        // ],

        // 店铺管理
        // [
        //   // 店铺管理
        //   {
        //     title: t("app.mineitem.storemanager"),
        //     icon: "shop-o",
        //     to: "StoreManagerList",
        //   },
        // ],

        // 地址相关
        [
          // 地址管理
          {
            title: t("app.mineitem.addressmanager"),
            icon: "location-o",
            to: "AddressList",
          },
        ],

        // 仓库相关
        [
          // 仓库管理
          {
            title: t("app.mineitem.warehousemanager"),
            icon: "wap-home-o",
            to: "WareHouseList",
          },
        ],

        // 报表相关
        // [
        //   // 报表相关
        //   {
        //     title: t("app.mineitem.reportmanager"),
        //     icon: "chart-trending-o",
        //     to: "ChartsList",
        //   },
        // ],

        // 语言切换
        [
          {
            title: t("app.mineitem.mylanguageitem"),
            icon: "exchange",
            to: "ChangeLanguage",
          },
          // 退出登录
          {
            title: t("app.mineitem.mylogout"),
            icon: "warning-o",
            to: "Logout",
          },
        ],
      ];
    } else {
      itemList = [
        // 序列号校验
        [
          {
            title: t("app.mineitem.mysecuritycheckitem"),
            icon: "font-o",
            to: "SecurityCheck",
          },
        ],

        // 质保相关
        [
          // 质保创建
          // {
          //   title: t("app.mineitem.mycreateqaitem"),
          //   icon: "add-o",
          //   to: "QaFormStepOne",
          // },
          // 质保查询
          // {
          //   title: t("app.mineitem.myqueryqaitem"),
          //   icon: "search",
          //   to: "QaList",
          // },
          // 质保管理
          {
            title: t("app.mineitem.myqareviewitem"),
            icon: "label-o",
            to: "QaReview",
          },
        ],

        // // 交易订单管理
        // [
        //   {
        //     title: t("app.mineitem.mypaymentorderitem"),
        //     icon: "shopping-cart-o",
        //     to: "ShopOrderList",
        //   },
        //   // {
        //   //   title: t("app.mineitem.mypaymentordermanageritem"),
        //   //   icon: "goods-collect-o",
        //   //   to: "PaymentOrder",
        //   // },
        // ],

        // 采购下单、订单管理
        [
          {
            title: t("app.mineitem.myshopitem"),
            icon: "bag-o",
            to: "ShopList",
          },
          {
            title: t("app.mineitem.myorderitem"),
            icon: "goods-collect-o",
            to: "PurchaseOrder",
          },
        ],

        // 库存相关
        [
          {
            title: t("app.mineitem.mystockinitem"),
            icon: "plus",
            to: "StockIn",
          },
          {
            title: t("app.mineitem.mystockoutitem"),
            icon: "minus",
            to: "StockOut",
          },
        ],

        // 经销商门店/零售商   人员管理
        [
          {
            title: t("app.mineitem.mydealermanageritem"),
            icon: "apps-o",
            to: "DealerShopManager",
          },
          {
            title: t("app.mineitem.workerlist"),
            icon: "bars",
            to: "WorkerList",
          },
        ],

        // 仓库相关
        [
          // 仓库管理
          {
            title: t("app.mineitem.warehousemanager"),
            icon: "wap-home-o",
            to: "WareHouseList",
          },
        ],

        // 券码管理/核销
        // [
        //   // {
        //   //   title: t("app.mineitem.mycouponitem"),
        //   //   icon: "coupon-o",
        //   //   to: "Coupon",
        //   // },
        //   {
        //     title: t("app.mineitem.couponmanageitem"),
        //     icon: "cluster-o",
        //     to: "DealerCoupon",
        //   },
        //   // {
        //   //   title: t("app.mineitem.mycouponcheckitem"),
        //   //   icon: "scan",
        //   //   to: "CouponScan",
        //   // },
        // ],

        // 店铺管理
        // [
        //   // 店铺管理
        //   {
        //     title: t("app.mineitem.storemanager"),
        //     icon: "shop-o",
        //     to: "StoreManagerList",
        //   },
        // ],

        // 地址相关
        // [
        //   // 地址管理
        //   {
        //     title: t("app.mineitem.addressmanager"),
        //     icon: "location-o",
        //     to: "AddressList",
        //   },
        // ],

        // 语言切换
        [
          {
            title: t("app.mineitem.mylanguageitem"),
            icon: "exchange",
            to: "ChangeLanguage",
          },
          // 退出登录
          {
            title: t("app.mineitem.mylogout"),
            icon: "warning-o",
            to: "Logout",
          },
        ],
      ];
    }
  } else if (userType == "DIRECT_VENDOR_USER") {
    // 直营商用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      // 索赔审批
      [
        {
          title: t("app.mineitem.myclaimapprovalitem"),
          icon: "todo-list-o",
          to: "ClaimApproval",
        },
      ],

      // 质保相关
      // [
      //   // 质保创建
      //   // {
      //   //   title: t("app.mineitem.mycreateqaitem"),
      //   //   icon: "add-o",
      //   //   to: "QaFormStepOne",
      //   // },
      //   // 质保查询
      //   // {
      //   //   title: t("app.mineitem.myqueryqaitem"),
      //   //   icon: "search",
      //   //   to: "QaList",
      //   // },
      //   // 质保管理
      //   // {
      //   //   title: t("app.mineitem.myqareviewitem"),
      //   //   icon: "label-o",
      //   //   to: "QaReview",
      //   // },
      // ],

      // 交易订单管理
      [
        // {
        //   title: t("app.mineitem.mypaymentorderitem"),
        //   icon: "bag-o",
        //   to: "ShopOrderList",
        // },
        {
          title: t("app.mineitem.mypaymentordermanageritem"),
          icon: "goods-collect-o",
          to: "PaymentOrder",
        },
        {
          title: t("app.mineitem.mypaymentorderbillmanageritem"),
          icon: "bill-o",
          to: "PaymentBillManage",
        },
      ],

      // 采购下单、订单管理
      // [
      //   {
      //     title: t("app.mineitem.myshopitem"),
      //     icon: "bag-o",
      //     to: "ShopList",
      //   },
      //   {
      //     title: t("app.mineitem.myorderitem"),
      //     icon: "goods-collect-o",
      //     to: "PurchaseOrder",
      //   },
      // ],

      // 库存相关
      [
        {
          title: t("app.mineitem.mystockinitem"),
          icon: "plus",
          to: "StockIn",
        },
        // {
        //   title: t("app.mineitem.mystockoutitem"),
        //   icon: "minus",
        //   to: "StockOut",
        // },
      ],

      // 经销商门店/零售商   人员管理
      // [
      //   {
      //     title: t("app.mineitem.mydealermanageritem"),
      //     icon: "apps-o",
      //     to: "DealerShopManager",
      //   },
      //   {
      //     title: t("app.mineitem.workerlist"),
      //     icon: "bars",
      //     to: "WorkerList",
      //   },
      // ],

      // 店铺管理
      [
        // 店铺管理
        {
          title: t("app.mineitem.storemanager"),
          icon: "shop-o",
          to: "StoreManagerList",
        },
        {
          title: t("app.mineitem.workerlist"),
          icon: "bars",
          to: "WorkerList",
        },
      ],

      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "RETAILER_USER") {
    // 零售商用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      // 质保相关
      [
        // 质保创建
        {
          title: t("app.mineitem.mycreateqaitem"),
          icon: "add-o",
          to: "QaForm",
        },
        // 质保查询
        {
          title: t("app.mineitem.myqueryqaitem"),
          icon: "search",
          to: "QaList",
        },

        // 赔付管理
        // {
        //   title: t("app.mineitem.mycompensationitem"),
        //   icon: "logistics",
        //   to: "CompensationList",
        // },
        // 质保管理
        // {
        //   title: t("app.mineitem.myqareviewitem"),
        //   icon: "label-o",
        //   to: "QaReview",
        // },
      ],

      [
        // 索赔
        {
          title: t("app.mineitem.myclaimitem"),
          icon: "records-o",
          to: "ClaimList",
        },
      ],

      // 交易订单管理
      // [
      //   {
      //     title: t("app.mineitem.mypaymentorderitem"),
      //     icon: "shopping-cart-o",
      //     to: "ShopOrderList",
      //   },
      //   // {
      //   //   title: t("app.mineitem.mypaymentordermanageritem"),
      //   //   icon: "goods-collect-o",
      //   //   to: "PaymentOrder",
      //   // },
      // ],

      // 交易订单管理
      // [
      //   {
      //     title: t("app.mineitem.mypaymentorderitem"),
      //     icon: "bag-o",
      //     to: "ShopOrderList",
      //   },
      //   // {
      //   //   title: t("app.mineitem.mypaymentordermanageritem"),
      //   //   icon: "goods-collect-o",
      //   //   to: "PaymentOrder",
      //   // },
      // ],

      // 订单管理
      // [
      //   {
      //     title: "订单管理",
      //     icon: "orders-o",
      //     to: "ConsumerOrderList",
      //   },
      // ],

      // 采购下单、订单管理
      [
        {
          title: t("app.mineitem.myshopitem"),
          icon: "bag-o",
          to: "ShopList",
        },
        // {
        //   title: t("app.mineitem.myorderitem"),
        //   icon: "goods-collect-o",
        //   to: "PurchaseOrder",
        // },
      ],

      // 库存相关
      [
        {
          title: t("app.mineitem.mystockinitem"),
          icon: "plus",
          to: "StockIn",
        },
        // {
        //   title: t("app.mineitem.mystockoutitem"),
        //   icon: "minus",
        //   to: "StockOut",
        // },
      ],

      // 仓库相关
      [
        // 仓库管理
        {
          title: t("app.mineitem.warehousemanager"),
          icon: "wap-home-o",
          to: "WareHouseList",
        },
      ],

      // 经销商门店/零售商   人员管理
      [
        // {
        //   title: t("app.mineitem.mydealermanageritem"),
        //   icon: "apps-o",
        //   to: "DealerShopManager",
        // },
        {
          title: t("app.mineitem.workerlist"),
          icon: "bars",
          to: "WorkerList",
        },
      ],

      // 券码管理/核销
      // [
      //   // {
      //   //   title: t("app.mineitem.mycouponitem"),
      //   //   icon: "coupon-o",
      //   //   to: "Coupon",
      //   // },
      //   {
      //     title: t("app.mineitem.couponmanageitem"),
      //     icon: "cluster-o",
      //     to: "DealerCoupon",
      //   },
      //   {
      //     title: t("app.mineitem.mycouponcheckitem"),
      //     icon: "scan",
      //     to: "CouponScan",
      //   },
      // ],

      // 地址相关
      [
        // 地址管理
        {
          title: t("app.mineitem.addressmanager"),
          icon: "location-o",
          to: "AddressList",
        },
      ],

      // 服务相关
      // [
      //   // 服务网点管理
      //   {
      //     title: t("app.mineitem.myservicecentermanager"),
      //     icon: "bars",
      //     to: "ServiceCenterList",
      //   },

      //   // 服务购买
      //   {
      //     title: t("app.mineitem.myservicepurchase"),
      //     icon: "bars",
      //     to: "ServicePurchase",
      //   },

      //   // 服务购买
      //   // {
      //   //   title: t("app.mineitem.myservicepurchase"),
      //   //   icon: "bars",
      //   //   to: "ServicePurchase",
      //   // },
      // ],

      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "SERVICE_PROVIDER_USER") {
    // 服务商用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      // 质保相关
      // [
      //   // 质保创建
      //   {
      //     title: t("app.mineitem.mycreateqaitem"),
      //     icon: "add-o",
      //     to: "QaFormStepOne",
      //   },
      //   // 质保查询
      //   {
      //     title: t("app.mineitem.myqueryqaitem"),
      //     icon: "search",
      //     to: "QaList",
      //   },
      //   // 质保管理
      //   {
      //     title: t("app.mineitem.myqareviewitem"),
      //     icon: "label-o",
      //     to: "QaReview",
      //   },
      // ],

      // 采购下单、订单管理
      // [
      //   {
      //     title: t("app.mineitem.myshopitem"),
      //     icon: "bag-o",
      //     to: "ShopList",
      //   },
      //   {
      //     title: t("app.mineitem.myorderitem"),
      //     icon: "goods-collect-o",
      //     to: "PurchaseOrder",
      //   },
      // ],

      // 库存相关
      // [
      //   {
      //     title: t("app.mineitem.mystockinitem"),
      //     icon: "plus",
      //     to: "StockIn",
      //   },
      //   {
      //     title: t("app.mineitem.mystockoutitem"),
      //     icon: "minus",
      //     to: "StockOut",
      //   },
      // ],

      // 经销商门店/零售商   人员管理
      [
        // {
        //   title: t("app.mineitem.mydealermanageritem"),
        //   icon: "apps-o",
        //   to: "DealerShopManager",
        // },
        {
          title: t("app.mineitem.workerlist"),
          icon: "bars",
          to: "WorkerList",
        },
      ],

      // 券码管理/核销
      // [
      //   // {
      //   //   title: t("app.mineitem.mycouponitem"),
      //   //   icon: "coupon-o",
      //   //   to: "Coupon",
      //   // },
      //   {
      //     title: t("app.mineitem.couponmanageitem"),
      //     icon: "cluster-o",
      //     to: "DealerCoupon",
      //   },
      //   {
      //     title: t("app.mineitem.mycouponcheckitem"),
      //     icon: "scan",
      //     to: "CouponScan",
      //   },
      // ],
      // 语言切换
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  } else if (userType == "SERVICE_PERSONNEL") {
    // 服务人员
  } else {
    // 服务商用户
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mysecuritycheckitem"),
          icon: "font-o",
          to: "SecurityCheck",
        },
      ],

      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        // 退出登录
        {
          title: t("app.mineitem.mylogout"),
          icon: "warning-o",
          to: "Logout",
        },
      ],
    ];
  }

  // // 是否登录
  if (!isLogin()) {
    itemList = [
      // 序列号校验
      [
        {
          title: t("app.mineitem.mylanguageitem"),
          icon: "exchange",
          to: "ChangeLanguage",
        },
        {
          title: t("app.mineitem.myloginin"),
          icon: "tv-o",
          to: "Login",
        },
      ],
    ];
  }

  console.log("itemList", itemList);
  // let itemList = [
  //   {
  //     title: t("app.mineitem.myqaitem"),
  //     icon: "user-o",
  //     to: "QaList",
  //   },
  //   {
  //     title: t("app.mineitem.mysecuritycheckitem"),
  //     icon: "font-o",
  //     to: "SecurityCheck",
  //   },
  //   {
  //     title: t("app.mineitem.myshopitem"),
  //     icon: "bag-o",
  //     to: "ShopList",
  //   },
  //   {
  //     title: t("app.mineitem.mystockitem"),
  //     icon: "bars",
  //     to: "Stock",
  //   },
  //   {
  //     title: t("app.mineitem.mygoodsitem"),
  //     icon: "goods-collect-o",
  //     to: "PurchaseOrder",
  //   },
  //   {
  //     title: t("app.mineitem.myqareviewitem"),
  //     icon: "label-o",
  //     to: "QaReview",
  //   },
  //   {
  //     title: t("app.mineitem.mydealermanageritem"),
  //     icon: "apps-o",
  //     to: "DealerShopManager",
  //   },
  //   {
  //     title: t("app.mineitem.myconstructionitem"),
  //     icon: "warn-o",
  //     to: "Construction",
  //   },
  //   {
  //     title: t("app.mineitem.mycouponitem"),
  //     icon: "coupon-o",
  //     to: "Coupon",
  //   },
  //   {
  //     title: t("app.mineitem.mycouponcheckitem"),
  //     icon: "scan",
  //     to: "CouponScan",
  //   },
  //   {
  //     title: t("app.mineitem.mycouponreportitem"),
  //     icon: "chart-trending-o",
  //     to: "ChartsCoupon",
  //   },
  //   {
  //     title: t("app.mineitem.myinstructionitem"),
  //     icon: "question-o",
  //     to: "Instruction",
  //   },
  //   {
  //     title: t("app.mineitem.mylanguageitem"),
  //     icon: "exchange",
  //     to: "ChangeLanguage",
  //   },
  //   {
  //     title: t("app.mineitem.mychartqaitem"),
  //     icon: "chart-trending-o",
  //     to: "QaChart",
  //   },
  //   {
  //     title: t("app.mineitem.mychartpurchaseorderitem"),
  //     icon: "chart-trending-o",
  //     to: "PurchaseOrderChart",
  //   },
  //   {
  //     title: t("app.mineitem.mycouponreportitem"),
  //     icon: "chart-trending-o",
  //     to: "ChartsCoupon",
  //   },
  //   {
  //     title: t("app.mineitem.workerlist"),
  //     icon: "chart-trending-o",
  //     to: "WorkerList",
  //   },
  // ];
  return { itemList };
};

export const useMineItemEffect = (t) => {
  const { itemList } = useChangeItemLanguageEffect(t);
  const mineItemList = ref(itemList);

  const updateTranslation = () => {
    const { itemList } = useChangeItemLanguageEffect(t);
    mineItemList.value = itemList;
  };
  return { itemList, mineItemList, updateTranslation };
};

export default {
  name: "NewMineItem",
  props: {
    // mineItemList: Array,
    mineItemList: {
      type: Array,
      default: () => [], // 使用函数返回一个新的对象，避免不同组件实例共享同一个对象引用
      //      // toRefs的原理:
      // proxy({name:'dell'}) -> {name:proxy({value:'dell'})}
    },
  },
  setup(props) {
    const router = useRouter();
    const { t } = useI18n(); // 获取 t 方法

    // const { mineItemList } = toRefs(props);
    // console.log("mineItemList", mineItemList);

    const onCellClick = (toPath) => {
      if (toPath == "Logout") {
        showConfirmDialog({
          message: t("app.logout.title"),
          confirmButtonText: t("app.logout.confirm"),
          cancelButtonText: t("app.logout.cancel"),
        })
          .then(() => {
            logout();
            router.replace({ name: "Login" });
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      if (toPath == "Login") {
        logout();
        router.replace({ name: "Login" });
        return;
      }

      // 商品购买入口：微信内置浏览器无法完成后续支付宝支付，弹提示（点「我知道了」消失），不跳转
      if (
        toPath === "ConsumerRetailerList" &&
        /MicroMessenger/i.test(navigator.userAgent)
      ) {
        showConfirmDialog({
          title: t("app.consumerorder.alipay_wechat_guide_title"),
          message: t("app.mineitem.wechat_purchase_hint"),
          confirmButtonText: t("app.consumerorder.alipay_wechat_pay_confirm"),
          showCancelButton: false,
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      router.push({ name: toPath });
    };
    return { onCellClick };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/viriables.scss";
.mine__cell {
  //   border-radius: 0.1rem;
  text-align: left;
  // margin-bottom: 0.1rem;
  // &::before {
  //   content: "";
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   height: 0.01rem;
  //   background: $darkBgColor;
  // }
}
.minewrapper {
  border: 0.01rem solid $light-fontColor;
  border-radius: 0.2rem;
  padding: 0.1rem 0.1rem;
  margin: 0.1rem 0.1rem;
  background: $bgColor;
}

::v-deep(.van-cell) {
  box-sizing: border-box;
  background: $bgColor;
  // border-bottom: 0.01rem solid $light-fontColor;
  // margin: 0 0.2rem;
  // padding-left: 0rem;
  padding: 0.2 0.2rem 0;
  border-radius: 0.08rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  width: 100%;
}
// .mine__cell::after {
// }

// ::v-deep(.van-cell::after) {
//   content: "";
//   display: block;
//   height: 0.01rem;
//   background: $darkBgColor;
// }
</style>